import EtelAPI from '../api/EtelAPI';

// JWT escape parsing method, token is already .split('.')[1];
function parseJwt (token) {
  var base64 = token.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

class AuthService {

  constructor( clientId, domain, redirectUri ) {
    this.ClientId = clientId;
    this.Domain = domain;
    this.RedirectUri = redirectUri;

    // Paths
    this.home = '/home';

    // Decoded user info
    this.user_info = {
      api: -1,
      react_user_id: -1,
      company_id: -1,
      company_type_id: -1,
      nickname: '',
      name: '',
      picture: '',
      updated_at: '',
      email: '',
      email_verified: false,
      iss: '',
      sub: '',
      aud: '',
      iat: 0,
      exp: 0
    }
    
    // Bindings
    this.loggedIn = this.loggedIn.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.getToken = this.getToken.bind(this);
    this.getParams = this.getParams.bind(this);
    this.getClientId = this.getClientId.bind(this);
    this.getDomain = this.getDomain.bind(this);
    this.getRedirectUri = this.getRedirectUri.bind(this);
    this.setRedirectUri = this.setRedirectUri.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
    this.getUserGroups = this.getUserGroups.bind(this);
  }

  // Returns profile infomation encoded in the JWT
  getProfile() {
    if( this.loggedIn() ){
      return this.user_info;

    } else {
      return {
        api: -1,
        react_user_id: -1,
        company_id: -1,
        company_type_id: -1,
        nickname: '',
        name: '',
        picture: '',
        updated_at: '',
        email: '',
        email_verified: false,
        iss: '',
        sub: '',
        aud: '',
        iat: 0,
        exp: 0
      }
    }
  }

  // Returns true or false if the id_token is defined, this value can be
  loggedIn( ) {
    if( this.getToken() ){
      return true;
    }

    return false;
  }

  // Returns the ClientId, Domain and RedirectUri as an Object
  getParams( ) {
    return ({
      ClientId: this.ClientId,
      Domain: this.Domain,
      RedirectUri: this.RedirectUri
    });
  }

  // Returns the ClientId
  getClientId( ) {
    return this.ClientId;
  }

  // Returns the Domain
  getDomain( ) {
    return this.Domain;
  }

  // Returns the RedirectUri
  getRedirectUri( ) {
    return this.RedirectUri;
  }

  // Sets the RedirectUri
  setRedirectUri( uri ) {
    this.RedirectUri = uri;
  }

  // Returns the same thing as getProfile
  getUserInfo( ) {
    return this.getProfile();
  }

  // Returns the group(s) of the user
  getUserGroups( ) {
    return new Promise( function( resolve, reject ) {
      let api = new EtelAPI( 'admin/usergroups' );
      api.get( {} ).then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  // Returns back the menu available to the user
  getUserMenus( ) {
    return new Promise( function( resolve, reject ) {
      let api = new EtelAPI( 'admin/menus' );
      const parameters = [
        {'MENU_COMPONENT': 'container'}
      ];
      api.get( parameters ).then( ( result ) => {
        let menus = [];
        let childmenus = [];

        // Build the parent menus
        for( let index = 0;index < result.length; index++ ) {
          const menu = result[ index ];
          if( menu.MENU_PARENT_ID === 0 ) {
            menus.push( menu );
          } else {
            childmenus.push( menu );
          }
        }

        // Build the child menus
        if( childmenus.length > 0 ) {
          for( let childindex = 0; childindex < childmenus.length; childindex++ ) {
            let childmenu = childmenus[ childindex ];
            for( let parentindex = 0; parentindex < menus.length; parentindex++ ) {
              let parentmenu = menus[parentindex];
              if( parentmenu.REACT_MENU_ID === childmenu.MENU_PARENT_ID ) {
                if( parentmenu.menuitems === undefined ) {
                  parentmenu.menuitems = [];
                }
                parentmenu.menuitems.push( childmenu );
              }
            }
          }
        }
        resolve( menus );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  // Sets the idToken, not used outside of this file according to VSC
  setToken( idToken, expiresAt ) {
    if( ( localStorage !== undefined ) && ( localStorage !== null ) ) {
      localStorage.setItem( 'id_token', idToken );
      localStorage.setItem( 'id_token_expires', expiresAt );
    }
  }

  // Gets the token from local storage then populates any user encrypted information
  getToken( ) {

    let token = undefined;

    if( ( localStorage !== undefined ) && ( localStorage !== null ) ) {

      token = localStorage.getItem( 'id_token' );

      if( ( token === null ) && ( token === undefined ) ) {

        return undefined;

      // Sets the value
      } else {
        if( this.user_info.api === -1 && token ){
          const token_array_split = token.split('.');
          const decoded_object = parseJwt(token_array_split[1]);
          const keys = Object.keys(decoded_object);

          for(let idx = 0; idx < keys.length; idx++) {
            let key = keys[idx];
            if(key.includes('/api')){
              this.user_info.api = decoded_object[key];
            } else if(key.includes('/react_user_id')){
              this.user_info.react_user_id = decoded_object[key];
            } else if(key.includes('/company_id')){
              this.user_info.company_id = decoded_object[key];
            } else if(key.includes('/company_type_id')){
              this.user_info.company_type_id = decoded_object[key];
            } else if(key === 'nickname'){
              this.user_info.nickname = decoded_object[key];
            } else if(key === 'name'){
              this.user_info.name = decoded_object[key];
            } else if(key === 'picture'){
              this.user_info.picture = decoded_object[key];
            } else if(key === 'updated_at'){
              this.user_info.updated_at = decoded_object[key];
            } else if(key === 'email'){
              this.user_info.email = decoded_object[key];
            } else if(key === 'email_verified'){
              this.user_info.email_verified = decoded_object[key];
            } else if(key === 'iss'){
              this.user_info.iss = decoded_object[key];
            } else if(key === 'sub'){
              this.user_info['sub'] = decoded_object[key];
            } else if(key === 'aud'){
              this.user_info.aud = decoded_object[key];
            } else if(key === 'iat'){
              this.user_info.iat = decoded_object[key];
            } else if(key === 'exp'){
              this.user_info.exp = decoded_object[key];
            }
          }
        }
      }
    }

    return token;
  }

  clearBearerToken() {
    if( ( localStorage !== undefined ) && ( localStorage !== null ) ) {
      localStorage.removeItem( 'id_token' );
      localStorage.removeItem( 'id_token_expires' );
      localStorage.removeItem( 'etel.displayname' );
    }
  }

  getExpiresAt() {
    if( (localStorage !== undefined ) && ( localStorage !== null ) ) {
      try {
        var expiresAt = localStorage.getItem('id_token_expires');
        if( expiresAt !== undefined && expiresAt !== null  ) {
          return expiresAt;
        }
      } catch( exception ) {
        return 0;
      }
    }
    return 0;
  }

  isTokenExpired = ( ) => {
    // Gets the current date/time milliseconds
    const now = Date.now() 
    // Expires At is in seconds so have to multiply by 1000 
    // to convert to milliseconds
    const expiresAt = parseInt(this.getExpiresAt(), 10) * 1000; 
    if( expiresAt ) {
      const diff = expiresAt - now;
      if( diff <= 0 ) {
        return true;
      }
    } else {
      return true;
    }
    return false;
  }

  // Logs the user out
  logout( ) {
    this.clearBearerToken();
  }
}

export default AuthService;



// WEBPACK FOOTER //
// ./src/security/AuthService.js